import React, { useEffect, useState } from 'react';
import { Modal, ModalSize, NotificationToaster } from 'components/notifications';
import { ButtonSave, Button } from 'components/buttons';
import { FormSelect } from 'components/form-fields';
import { LocationService, UserService } from 'services';
import { Intent } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const defaultObject = {};

export function MoveAsset(
    {
        profile = defaultObject,
        isVisible = false,
        closeModal = () => { },
        saveAssetLocation = () => { },
        isSaving = false,
        assetType
    }
) {
    const [locations, setLocations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [moveAssetLocationId, setMoveAssetLocationId] = useState({});

    useEffect(() => {
        if (profile && isVisible) {
            setIsLoading(true);
            LocationService.getLocationBusinessAreas().then(function (locBusAreas) {
                if (assetType.visOnly) {
                    var vislocBusAreas = locBusAreas.find(b => b.businessArea === "VIS")
                    locBusAreas = vislocBusAreas ? [vislocBusAreas.locationBusinessAreaId] : [];
                } else {
                    locBusAreas = locBusAreas.map(b => b.locationBusinessAreaId);
                }
                if (locBusAreas && locBusAreas.length > 0) {
                    UserService.getLoggedInUserLocationListForMultipleBusinessAreas(locBusAreas).then(function (locList) {
                        setLocations(locList);
                    })
                    .catch(() => {
                        NotificationToaster.show(Intent.DANGER, `Failed to get location data. Please refresh the page.`);
                    })
                    .finally(() => {
                        setMoveAssetLocationId(profile.assetLocation?.location)
                        setIsLoading(false);
                    });
                }
            })
            .catch(() => {
                NotificationToaster.show(Intent.DANGER, `Failed to get business areas. Please refresh the page.`);
                setIsLoading(false);
            });
        }

    }, [profile, isVisible])

    function onLocationSelect(value) {
        setMoveAssetLocationId(value)
    }

    function moveLocation() {
        saveAssetLocation(moveAssetLocationId);
        closeModal();
    }

    return (
        <Modal title="Move Asset" isOpen={isVisible} onClose={closeModal} size={ModalSize.SMALL}>
            <p>Which location would you like to move the asset to?</p>
            <FormSelect
                id='move asset location'
                items={locations}
                onItemSelect={onLocationSelect}
                selectedValue={moveAssetLocationId?.id}
                loading={isLoading}
                placeholder="Select location"
                disabled={isLoading || isSaving}

            />
            <div className="bp6-dialog-footer">
                <div className="bp6-dialog-footer-actions">
                    <ButtonSave text="Save and close" intent="primary" onClick={moveLocation} disabled={isLoading || isSaving} />
                    <Button text="Cancel" intent="secondary" onClick={closeModal} disabled={isLoading || isSaving} />
                </div>
            </div>
        </Modal>
    )
}

MoveAsset.propTypes = {
    profile: PropTypes.object,
    isVisible: PropTypes.bool,
    closeModal: PropTypes.func,
    saveAssetLocation: PropTypes.func.isRequired,
    isSaving: PropTypes.bool.isRequired,
    assetType: PropTypes.object.isRequired
};